import { motion } from 'framer-motion';
import type { ReactNode } from 'react';

type Props = {
  eyebrow?: string;
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  align?: 'left' | 'center';
  className?: string;
};

export default function Section({
  eyebrow,
  title,
  description,
  children,
  align = 'left',
  className = '',
}: Props) {
  return (
    <section className={`container-page py-20 md:py-28 ${className}`}>
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className={`max-w-2xl ${align === 'center' ? 'mx-auto text-center' : ''}`}
      >
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h2 className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight text-white md:text-4xl">
          {title}
        </h2>
        {description && (
          <p className="mt-4 text-base leading-relaxed text-white/65 md:text-lg">
            {description}
          </p>
        )}
      </motion.div>
      {children && <div className="mt-12">{children}</div>}
    </section>
  );
}
